import React from "react";
import Icon from "@ant-design/icons";

const BranchNameSvg = ({ width = "1rem", height = "1rem", fill = "none" }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox={`0 0 ${width} ${height}`}
		height={height}
		width={width}
		fill={fill}
	>
		<path
			d="M7.99984 1.99805L0.666504 5.99805L3.33317 7.45138V11.4514L7.99984 13.998L12.6665 11.4514V7.45138L13.9998 6.72471V11.3314H15.3332V5.99805L7.99984 1.99805ZM12.5465 5.99805L7.99984 8.47805L3.45317 5.99805L7.99984 3.51805L12.5465 5.99805ZM11.3332 10.658L7.99984 12.478L4.6665 10.658V8.17805L7.99984 9.99805L11.3332 8.17805V10.658Z"
			fill="#9E9E9E"
		/>
	</svg>
);
const BranchNameIcon = (props) => (
	<Icon component={() => <BranchNameSvg {...props} />} />
);

export default BranchNameIcon;
